<div class="cardholder-container" *ngIf="config">
  <img src="assets/main-game/character/{{ config.gender }}/body.png" alt="" />
  <img
    src="assets/main-game/character/{{ config.gender }}/hair_{{
      config.hair
    }}.png"
    alt=""
  />
  <img
    src="assets/main-game/character/{{ config.gender }}/face_{{
      config.face
    }}.png"
    alt=""
  />
  <!-- <img
          src="assets/main-game/character/{{ config.sex }}/body_{{ config.body }}.png"
          alt=""
        /> -->
  <img
    src="assets/main-game/character/{{ config.gender }}/cloth_{{
      config.cloth
    }}.png"
    alt=""
  />
  <img
    src="assets/main-game/character/{{ config.gender }}/atr_{{
      config.attribute
    }}.png"
    alt=""
  />
</div>
